console.log('script.js が読み込まれました');

// スライダー初期化のコア機能を関数として分離（即座にグローバルに設定）
function initializeVanillaSliders(containerSelector = '.vanilla-slider-container') {
  console.log('スライダー初期化開始:', containerSelector);
  
  // 指定されたセレクタでスライダーコンテナを検索（未初期化のもののみ）
  const sliderContainers = document.querySelectorAll(`${containerSelector}:not(.initialized)`);
  console.log('見つかったスライダー数:', sliderContainers.length);
  
  sliderContainers.forEach((container, index) => {
    // 一意なIDを設定（デバッグ用）
    if (!container.getAttribute('data-slider-id')) {
      container.setAttribute('data-slider-id', `slider-${Date.now()}-${index}`);
    }
    
    const sliderId = container.getAttribute('data-slider-id');
    console.log(`スライダー初期化開始: ${sliderId}`);
    
    const sliderWrapper = container.querySelector('.vanilla-slider-wrapper');
    const slides = container.querySelectorAll('.vanilla-slide');
    const prevButton = container.querySelector('.slider-arrow.prev');
    const nextButton = container.querySelector('.slider-arrow.next');
    const dotsContainer = container.querySelector('.slider-dots');
    
    if (!sliderWrapper || slides.length === 0) {
      console.error('Slider elements not found for a container.');
      return;
    }
    
    let currentIndex = 0;
    let slideCount = slides.length;
    
    // --- ドットナビゲーションの生成 ---
    // 既存のドットをクリア
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      
      for (let i = 0; i < slideCount; i++) {
        const dot = document.createElement('button');
        dot.classList.add('slider-dot');
        dot.setAttribute('aria-label', `スライド ${i + 1}へ移動`);
        dot.addEventListener('click', () => {
          goToSlide(i);
        });
        dotsContainer.appendChild(dot);
      }
    }
    
    const dots = dotsContainer ? dotsContainer.querySelectorAll('.slider-dot') : [];
    
    // --- スライド移動のコア関数 ---
    function goToSlide(index) {
      if (index < 0 || index >= slideCount) return;
      
      const slideWidth = slides[0].clientWidth;
      sliderWrapper.style.transform = `translateX(-${index * slideWidth}px)`;
      currentIndex = index;
      updateNavigation();
    }
    
    // --- ナビゲーション（矢印・ドット）の状態更新 ---
    function updateNavigation() {
      // ドットのアクティブ状態を更新
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentIndex);
      });
      
      // 矢印の無効化/有効化
      if (prevButton) prevButton.classList.toggle('disabled', currentIndex === 0);
      if (nextButton) nextButton.classList.toggle('disabled', currentIndex === slideCount - 1);
    }
    
    // --- イベントリスナーの設定 ---
    // 次へボタン
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        if (currentIndex < slideCount - 1) {
          goToSlide(currentIndex + 1);
        }
      });
    }
    
    // 前へボタン
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        if (currentIndex > 0) {
          goToSlide(currentIndex - 1);
        }
      });
    }
    
    // --- フリック（タッチ）対応 ---
    let touchStartX = 0;
    let touchEndX = 0;
    const swipeThreshold = 50;
    
    sliderWrapper.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    });
    
    sliderWrapper.addEventListener('touchmove', (e) => {
      touchEndX = e.touches[0].clientX;
    });
    
    sliderWrapper.addEventListener('touchend', () => {
      const swipeDistance = touchStartX - touchEndX;
      if (swipeDistance > swipeThreshold) {
        if (currentIndex < slideCount - 1) {
          goToSlide(currentIndex + 1);
        }
      } else if (swipeDistance < -swipeThreshold) {
        if (currentIndex > 0) {
          goToSlide(currentIndex - 1);
        }
      }
    });
    
    // --- レスポンシブ対応 ---
    const resizeHandler = () => {
      goToSlide(currentIndex);
    };
    
    window.addEventListener('resize', resizeHandler);
    
    // --- 初期化処理 ---
    goToSlide(0);
    container.classList.add('initialized');
    
    console.log(`スライダー初期化完了: ${sliderId}`, {
      slideCount,
      slideWidth: slides[0].offsetWidth
    });
  });
  
  console.log('スライダー初期化処理完了');
  return sliderContainers.length; // 初期化されたスライダー数を返す
}

// グローバル関数として即座に公開（DOMContentLoadedを待たない）
window.initializeVanillaSliders = initializeVanillaSliders;
console.log('グローバル関数 initializeVanillaSliders を設定しました');

// DOMContentLoadedでの初期化（既存の動作）
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOMContentLoaded - スライダー初期化実行');
  initializeVanillaSliders();
});

// ページ完全読み込み後の初期化（保険として）
window.addEventListener('load', function() {
  // まだ初期化されていないスライダーがあれば初期化
  const uninitializedSliders = document.querySelectorAll('.vanilla-slider-container:not(.initialized)');
  if (uninitializedSliders.length > 0) {
    console.log('ページ読み込み完了後に未初期化スライダーを検出:', uninitializedSliders.length);
    initializeVanillaSliders();
  }
});